import {
  Datagrid,
  NumberField,
  TextField,
  TopToolbar,
  Filter,
  NumberInput,
  TextInput,
  FunctionField,
  AutocompleteInput,
  SelectInput,
} from "react-admin";
import {
  DateField,
  CustomList,
  EmptyMessage,
} from "../../../shared/components/index.js";

const names = [
  { id: "np", name: "np" },
  { id: "app-", name: "app-" },
  { id: "app-user-", name: "app-user-" },
  { id: "izi", name: "izi" },
  { id: "p-4 Litrol", name: "p-4 Litrol" },
  { id: "p-5 MultiOil", name: "p-5 MultiOil" },
  { id: "p-6 Beep!", name: "p-6 Beep!" },
  { id: "p-7 Autoclub", name: "p-7 Autoclub" },
  { id: "p-8 DayDrive", name: "p-8 DayDrive" },
  { id: "p-10 Oranta", name: "p-10 Oranta" },
  { id: "p-11 Urbanist", name: "p-11 Urbanist" },
];

const DatexTransactionFilter = (props) => {
  return (
    <Filter {...props}>
      <AutocompleteInput
        source="fn_card_owner"
        choices={names}
        optionText="name"
        optionValue="id"
        alwaysOn
        resettable
        filterToQuery={(searchText) => ({ fn_card_owner: searchText })}
      />
      <SelectInput
        source="is_passed"
        choices={[
          { id: true, name: "PROCESSED" },
          { id: false, name: "FAILED" },
        ]}
        optionText="name"
        optionValue="id"
        alwaysOn
        resettable
      />
      <TextInput source="n_account" alwaysOn />
      <NumberInput source="amount" alwaysOn />
    </Filter>
  );
};
const DatexTransactionList = (props) => {
  return (
    <CustomList
      filters={<DatexTransactionFilter {...props} />}
      actions={<TopToolbar />}
    >
      <Datagrid
        empty={<EmptyMessage />}
        rowClick={false}
        bulkActionButtons={false}
      >
        <TextField source="fn_card_owner" />
        <NumberField source="card_id" />
        <TextField source="serial_visible" />
        <NumberField source="amount" />
        <NumberField source="sum" />
        <TextField source="n_account" />
        <TextField source="n_service_station" />
        <TextField source="address" />
        <FunctionField
          source="is_passed"
          render={(record) =>
            record.is_passed === true ? "PROCESSED" : "FAILED"
          }
        />
        <DateField source="session_time" />
      </Datagrid>
    </CustomList>
  );
};

export default DatexTransactionList;
